import Organization from '~/models/organization'
import Service from '~/models/service'
import System from '~/models/system'
import { OrganizationColor } from '~/common/define/color'
import { notEmptyModel } from '~/common/utils/model'
import { TagProps } from '~/components/atoms/tag/Tag'
import News from '~/models/news'
import Tool from '~/models/tool'
import Activity from '~/models/activity'
import VisFile from '~/models/file'

const makeSpaceTagPropsList = (organization: Organization, service: Service, system: System): TagProps[] => {
  if (notEmptyModel(system)) {
    return [
      {
        text: system.service ? system.service.name : service.name,
        color: system.service ? system.service.color : service.color,
      },
      {
        text: system.name,
        color: system.color
      }
    ]
  }

  if (notEmptyModel(service)) {
    return [
      {
        text: service.name,
        color: service.color
      }
    ]
  }

  return [
    {
      text: organization.name,
      color: OrganizationColor.ORGANIZATION
    }
  ]
}

export const makeToolTagPropsList = (tool: Tool|VisFile): TagProps[] => {
  return makeSpaceTagPropsList(null, tool.service, tool.system)
}

export const makeActivityTagPropsList = (activity: Activity): TagProps[] => {
  return makeSpaceTagPropsList(activity.organization, activity.service, activity.system)
}

export const makeNewsSpaceTagPropsList = (news: News): TagProps[] => {
  if (news.service) {
    return [
      newsSpaceTagProps(news.service.organization),
      newsSpaceTagProps(news.service)
    ]
  }

  return [newsSpaceTagProps(news.organization)]
}

export const newsSpaceTagProps = (space: Organization|Service): TagProps => {
  return {
    text: space.name,
    color: space.color ?? OrganizationColor.ORGANIZATION,
  }
}